<template>
  <div class="portlet">
    <div class="id-info">
        <!-- <div class="item">
            <span class="title">报考级别：</span>
            <span class="ver-info">{{Number(level)===1?'初级财务数据分析师':Number(level)===2?'财务数据分析师（单证）':'财务数据分析师（双证）'}}</span>
        </div> -->
        <div class="item">
            <span class="title">报考方式：</span>
            <span class="ver-info">学习卡</span>
        </div>
        <div class="item">
            <span class="title">学习卡号：</span>
            <span class="dot">*</span>
            <input v-model="num" class="input-large" style="height: 12px;width: 150px;margin-left:10px">
            <div class="tip">激活课程所需要的学习卡，请联系管理员</div>
        </div>
    </div>
    <div class="step-btn" @click="next">激活
        <i class="fa icon-arrow-right"/>
    </div>
  </div>
</template>
<script>
export default {
    props:{
        level:{
            type:Number,
            default: () => 1,
        },
        which:{
            type:String,
            default: () => '',
        },
    },
    data() {
        return {
            num:'',
        }
    },
    methods: {
        async next(){
            if(this.num === ''){
                this.$toast('请输入学习卡号');
                return false;
            }
            try {
                const res = await this.$http.post('/api/course/activeCourse',{card_no:this.num});
                if(res){
                    const res2 = await this.$store.dispatch('UPDATE_USERINFO',this.$http);
                    if(res2){
                        let path = '/',
                            message = '注册成功'
                        if(this.which === 'course'){
                            path = '/course';
                            message = '激活成功';
                        }
                        this.$store.commit('CHANGE_STATE',{userInfo:res2});
                        this.$toast(message);
                        const tem = setTimeout(() => {
                            this.$router.push(path);
                            clearTimeout(tem);
                        }, 1500);
                    }
                }
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
            
        }
    },
}
</script>
<style lang="scss" scoped>
@import '../../assets/user.scss';
.id-info{
    width:100%;
    padding-left: 15px;
    .item{
        margin-bottom: 25px;
        position: relative;
        .tip{
                position: absolute;
                bottom: -19px;
                font-size: 9px;
                left: 85px;
                color: grey;
        }
        span{
            display: inline-block;
            vertical-align: middle;
        }
        .dot{
            color: red;
            position: absolute;
        }
        select{
            width: 160px;
            height: 25px;
            margin-left: 5px;
        }
        .title{
            text-align: right;
            width: 75px;
        }
        img{
            width: 76px;
            vertical-align: middle;
            border: 1px solid #dfdbdb;
            border-radius: 2px;
            margin-right: 25px;
        }
        .ver-info{
            width: 220px;
            height: 30px;
            line-height: 28px;
            margin-left: 5px;
            font-size: 16px;
            font-weight: 500;
        }
    }
}
</style>
